document.addEventListener("DOMContentLoaded", (event) => {
    slideDots();
})

function slideDots() {

    const slidersWrapper = document.querySelector(".product__multimedia");
    const sliders = document.querySelectorAll(".product__media");
    for (let i = 0; i < sliders.length; ++i) {
        const slider = sliders[i];
        const dots = slidersWrapper.querySelector(".dots");
        const sliderImgs = slider.querySelectorAll(".product__media-wrapper");

        let currImg = 0;
        let prevImg = sliderImgs.length - 1;

        // Creates dots and add listeners to them
        for (let i = 0; i < sliderImgs.length; ++i) {
            const dot = document.createElement("div");
            dot.classList.add("dot");
            dots.appendChild(dot);
            dot.addEventListener("click", dotClick.bind(null, i), false);
        
            document.addEventListener('scroll', (e) => {
                let offsetHeight = window.pageYOffset;
                let offsetImg = sliderImgs[i].offsetTop;
                if (offsetHeight >= offsetImg) {     
                    if (i == currImg) {
                        return false;
                    } 
    
                    if (i > currImg) {
                        nextImg = i;
                        prevImg = currImg;
                        currImg = nextImg;
    
                        currDot = allDots[currImg];
                        currDot.classList.add("active-dot");
                        prevDot = allDots[prevImg];
                        prevDot.classList.remove("active-dot");
                    }else{
                        nextImg = i;
                        prevImg = currImg;
                        currImg = nextImg;
    
                        currDot = allDots[currImg];
                        currDot.classList.add("active-dot");
                        prevDot = allDots[prevImg];
                        prevDot.classList.remove("active-dot");
                    }
                } 
            })
        }

        const allDots = dots.querySelectorAll(".dot");
        allDots[0].classList.add("active-dot");

        sliderImgs[0].style.top = "0";
        /**
         * Animates images
         * @param {number} [nextImg] - index of next image to show
         * @param {boolean} [bottom = false] - animate to bottom
         */
        function animateSlider(nextImg) {
            if (!nextImg)
                nextImg = currImg + 1;
            --nextImg;

            sliderImgs[prevImg].style.top = "";
            window.scrollTo(sliderImgs[currImg].offsetTop, sliderImgs[nextImg].offsetTop);

            prevImg = currImg;
            currImg = nextImg;

            currDot = allDots[currImg];
            currDot.classList.add("active-dot");
            prevDot = allDots[prevImg];
            prevDot.classList.remove("active-dot");
        }

        /**
         * Decides if animate to left or right and highlights clicked dot
         * @param {number} num - index of clicked dot
         */
        function dotClick(num) {
            if (num == currImg)
                return false;

            if (num > currImg)
                animateSlider(num + 1);
            else
                animateSlider(num + 1, true);
        }

    }

}

